import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentApproved(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={76}
        height={94}
        x={50}
        y={13}
        stroke="url(#document_approved_svg__a)"
        strokeWidth={10}
        rx={13.333}
      />
      <path stroke="#0D2B57" d="M67 34.5h42m-42 10h42" />
      <rect width={39} height={39} x={106.5} y={54.5} fill="#0D2B57" rx={19.5} />
      <rect width={39} height={39} x={106.5} y={54.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m120.167 75.25 3.5 3.75 8.166-10"
      />
      <defs>
        <linearGradient
          id="document_approved_svg__a"
          x1={88}
          x2={88}
          y1={13}
          y2={107}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentApproved);
export default ForwardRef;
